<template>
    <page>
        <module title="授信额度详情">
            <c-detail >
                <c-detail-item label="申请单号" >
                    {{detailData.apply_number}}
                </c-detail-item>
                <c-detail-item label="状态" >
                  <span style="color:red" v-if="detailData.state==0">{{stateName[detailData.state]}}</span>
                  <span style="color:dodgerblue" v-if="detailData.state==1">{{stateName[detailData.state]}}</span>
                  <span style="color:green" v-if="detailData.state==2">{{stateName[detailData.state]}}</span>
                  <span style="color:#999999" v-if="detailData.state==-1">{{stateName[detailData.state]}}</span>
                </c-detail-item>
                <c-detail-item label="金额" >
                    <span style="color:dodgerblue" v-if="detailData.credit_money && detailData.credit_money>0">￥{{detailData.credit_money.toFixed(2)}}</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="会员名称" >
                    {{detailData.nick_name||'--'}}
                </c-detail-item>
                <c-detail-item label="会员手机号" >
                    {{detailData.user_manage_mobilephone}}
                </c-detail-item>
                <c-detail-item label="会员账号" >
                    {{detailData.login_name||'--'}}
                </c-detail-item>
                <c-detail-item  v-if="detailData.state ==1 || detailData.state ==2 || detailData.state =='-1' " label="申请时间">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item  v-if="detailData.state ==1 || detailData.state ==2 || detailData.state =='-1' " label="申请人姓名">
                    {{detailData.apply_name}}
                </c-detail-item>
                <c-detail-item v-if="detailData.state == 2 || detailData.state == '-1'" label="审批时间">
                    {{detailData.audit_date}}
                </c-detail-item>
                <c-detail-item v-if="detailData.state == 2 || detailData.state == '-1'" label="审批人姓名">
                    {{detailData.approval_name}}
                </c-detail-item>
                <c-detail-item  v-if="detailData.state =='-1' " label="驳回原因" full>
                    {{detailData.rejected_reason}}
                </c-detail-item>
                <c-detail-item label="备注" full>
                    {{detailData.remark}}
                </c-detail-item>
            </c-detail>

            <template slot="button">
                <c-button size="m" v-if="detailData.state == 1" power="b_credit_quota_apply" @click="approval(detailData,2)">审批</c-button>
                <c-button size="m" v-if="detailData.state == 1" power="b_credit_quota_apply" hollow @click="approval(detailData,'-1')">驳回</c-button>
            </template>
        </module>

        <c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="orderApprovalHandle">
            <div class="approval-eason">
                <textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
            </div>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'credit_quota_detail',
        props: {
            id: String
        },
        data() {
            return {
                detailData: {},
                approvalReason: '',
                stateName: {
                  0: '草稿',
                  1: '待审核',
                  2: '审批通过',
                  '-1': '驳回'
                }
            }
        },
        mounted() {
            this.detailData = {};
            this.detail();
        },
        methods: {
            detail() {
                this.request({
                    url: '/credit_quota/detail',
                    data: {id: this.id},
                    loading: true,
                    success: data => {
                        this.detailData = data;
                    }
                });
            },
            orderApprovalHandle(stop){

                if (!this.approvalReason.trim()) {
                    this.$message({
                        text: '请填写驳回原因'
                    });
                    stop();
                    return;
                }
                this.request({
                    url: '/credit_quota/apply',
                    data: {id:this.id,state:'-1',rejected_reason:this.approvalReason.trim()},
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '驳回成功',
                            icon: 'success'
                        });
                        this.$bus.$emit('credit_quota.update', {})
                        this.redirectTo('/credit_quota');
                    }
                });
            },
            approval(val,state) {
                if(state == '-1'){
                    this.$refs.approvalReason.open();
                }else if(state == 2){
                    this.$confirm({
                        text: '确定要审批通过【'+val.apply_number+'】吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/credit_quota/apply',
                                data: {id:val.id,state:state},
                                loading: true,
                                success: data => {
                                    this.$message({
                                        text: '审批通过成功',
                                        icon: 'success'
                                    });
                                    this.$bus.$emit('credit_quota.update', {})
                                    this.redirectTo('/credit_quota');
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .approval-eason {
    padding: 20px;

    textarea {
      box-sizing: border-box;
      width: 100%;
      height: 120px;
      border: none;
      padding: 10px 14px;
      line-height: 20px;
      background: #FAFAFA;
      resize: none;
    }
  }
</style>